<template>
  <div>
    <checks-list-desktop-bridge v-if="isDesktopListLayout" />
    <checks-list-mobile v-else />
    <accounting-doc-view
      v-model="docView.open"
      :item="docView.item"
      @edit="openDocEdit"
      @error="serverErrorHandeler"
    />
    <treasury-receipt-print
      v-if="receiptKind"
      ref="receiptPrint"
      :kind="receiptKind"
      @error="serverErrorHandeler"
    />
    <cheque-studio
      v-model="chequeStudio.open"
      report="cheque-pay"
      :fields="chequeFields"
      :cheques="chequeStudio.items"
      :subtitle="chequeStudio.subtitle"
    />
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-dialog
      v-model="checkStatusDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="checkStatusDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("status") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <checkStatus v-model="lastStatus" :check-item="checkItem" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    print dialog-->
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <div style="position: fixed; z-index: 2">
            <v-btn icon color="grey darken-2" @click="printDialog = false">
              <v-icon class="close-hover" large> mdi-close </v-icon>
            </v-btn>
          </div>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :items-prop="items"
            :dialog="printDialog"
            :turnover-prop="totals"
            :from-date="fromDate"
            :to-date="toDate"
            :title="$t('list') + ' ' + $t(type)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
        <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ checksFilterDialogTitle }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-account-outline</v-icon>
              {{ $t("costFilterParties") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="account"
                :title="type == 'payCheck' ? $t('reciever') : $t('payer')"
                type="person"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-if="type == 'payCheck'"
                v-model="bank"
                :title="$t('bank')"
                type="bank"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-if="type == 'recieveCheck'"
                v-model="bankRecieve"
                :title="$t('bank')"
                type="bankCheckRecieve"
                :filter="false"
                :multiple="true"
              />
              <autocomplete
                v-model="currencyFilter"
                :title="$t('currency')"
                type="currency"
                :filter="true"
                :multiple="true"
              />
              <v-select
                v-model="status"
                :label="$t('status')"
                :items="statusItems"
                dense
                outlined
                multiple
                clearable
                hide-details
                item-value="value"
                item-text="text"
                item-disabled="disable"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum((status || []).length - 1) }}
                  </span>
                </template>
              </v-select>
              <tag v-model="tag" />
              <autocomplete
                v-if="type == 'recieveCheck'"
                v-model="cashBox"
                :title="$t('cashBox')"
                type="getCash"
                :filter="true"
                :multiple="true"
              />
              <autocomplete
                v-model="registerar"
                :title="$t('registerar')"
                type="partners"
                :multiple="true"
                :filter="true"
              />
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-calendar-range</v-icon>
              {{ $t("accFilterDateTime") }}
            </div>
            <div class="acf-grid acf-grid--4">
              <div>
                <v-text-field
                  id="fromId"
                  v-model="fromDate"
                  :label="$t('from') + ' ' + $t('dueDate')"
                  prepend-inner-icon="mdi-calendar-start"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="fromDate"
                  element="fromId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
              <div>
                <v-text-field
                  id="toId"
                  v-model="toDate"
                  :label="$t('until') + ' ' + $t('dueDate')"
                  prepend-inner-icon="mdi-calendar-end"
                  outlined
                  dense
                  clearable
                  hide-details
                />
                <date-picker
                  v-model="toDate"
                  element="toId"
                  :locale="$store.state.date_locale"
                  :format="$store.state.date_format"
                  :min="fromDate"
                  auto-submit
                  :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                  @close="setDate"
                />
              </div>
            </div>
          </section>

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-office-building-outline</v-icon>
              {{ $t("sellFilterOrg") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="branch"
                title="branch"
                type="branch"
                :filter="true"
                :multiple="true"
              />
              <v-select
                v-model="lockStatus"
                :label="$t('lockStatusDocuments')"
                :items="lockStatusItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
<v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="documentPrintDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="documentPrintDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <documentPrint :id-prop="documentId" />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--checkAverageDialog-->
    <v-dialog
      v-model="checkAverageDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="600"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-1">{{ $t("check-list") }}</v-card-text>
          <v-icon size="15" @click="checkAverageDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-space-between align-end my-6">
          <div>
            <v-card-text class="pa-0 text-body-2">
              {{ $t("count") }} : {{ selectedCheck ? selectedCheck.length : "" }}
              {{ $t("numbers") }}
            </v-card-text>
            <v-card-text class="pa-0 text-body-2 mt-1">
              {{ $t("sumAmount") }} : {{ checksTotal ? $numberFormat(checksTotal) : 0 }}
              {{ $t("rial") }}
            </v-card-text>
            <v-card-text class="pa-0 text-body-1 mt-1">
              {{ $t("checks-count") }} :
              {{
                checkAverageDate ? checkAverageDate.split("T")[0].replace(/-/g, "/") : ""
              }}
            </v-card-text>
          </div>
          <div class="d-flex justify-end flex-column">
            <v-btn
              color="primary"
              height="32"
              class="mb-4 mr-12"
              :loading="loading"
              @click="fetchCheckAverageSecond"
            >
              {{ $t("check-head-recalculation") }}
            </v-btn>
            <template>
              <v-text-field
                id="selectedDate"
                v-model="selectedDate"
                :label="$t('date')"
                append-icon="mdi-calendar"
                :rules="[(v) => !!v || $t('is-required')]"
                outlined
                dense
                clearable
                :class="{ 'mt-5': isMobile }"
              />
              <date-picker
                v-model="selectedDate"
                element="selectedDate"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :min="$store.state.startDate"
                :max="$store.state.endDate"
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </div>
        </v-container>
        <v-data-table
          :headers="checkAverageHeaders"
          :items="checkAverageItems"
          :items-per-page="-1"
          hide-default-footer
          :height="isMobile || isTablet ? 265 : 265"
          style="background-color: #eeeeee"
          fixed-header
          class="checkAverage"
          :class="{ 'ma-5': isMobile }"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text class="pa-0 text-caption">
              {{ index + 1 }}
            </v-card-text>
          </template>
          <template v-slot:item.checkNumber="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.number ? item.number : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.detailsInvoice="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.account ? item.account.name : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.dueDate="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.due_date ? item.due_date : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.amount="{ item }">
            <v-card-text v-if="item.amount" class="pa-0 text-caption">
              {{ $numberFormat(item.amount) }} {{ item.currency.name }}
            </v-card-text>
            <v-card-text v-else class="pa-0 text-caption">
              {{ $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:item.bank="{ item }">
            <v-card-text class="pa-0 text-caption">
              {{ item.bank_name ? item.bank_name : $t("haveNot") }}
            </v-card-text>
          </template>
          <template v-slot:header.edit="{ header }">
            <div @click="openCheckDeleteDialog('all')">
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :cursor-pointer="true"
              />
            </div>
          </template>
          <template v-slot:item.edit="{ item, index }">
            <div @click="openCheckDeleteDialog('single', item.id)">
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :cursor-pointer="true"
              />
            </div>
          </template>
        </v-data-table>
        <v-card-text
          v-if="isThereInvoiceWithoutId"
          class="pa-0 text-body-2 mt-1"
          style="color: #ff5252"
        >
          {{ $t("only checks with due-date can be calculated") }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--delete dialog-->
    <v-dialog
      v-model="checkDeleteDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">
          {{
            deleteAllCheck
              ? $t("are you sure you want to delete all items?")
              : $t("Are you sure you want to delete this item ?")
          }}
        </v-card-text>
        <v-container class="pa-0 d-flex align-center gap-1 mt-7">
          <v-btn color="error" height="32" @click="deleteCheck">
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            outlined
            height="32"
            color="secondary"
            @click="checkDeleteDialog = false"
          >
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="recieveCheck"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Task from "../task/task";
import Upload from "../../components/general/upload/upload";
import General from "../../../../Mixins/general";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";
import ChecksListDesktopBridge from "./layouts/desktop/ChecksListDesktopBridge.vue";
import ChecksListMobile from "./layouts/mobile/ChecksListMobile.vue";
import Vue from "vue";
import ChequeStudio from "@/modules/print/ChequeStudio.vue";
import TreasuryReceiptPrint from "./layouts/TreasuryReceiptPrint.vue";
import AccountingDocView from "@/views/dashboard/pages/accounting/layouts/AccountingDocView.vue";
import { numberToWords, jalaliDateWords } from "@/modules/print/words";
import checkStatus from "./checkStatus";
import documentPrint from "../accounting/print";
import dialogComponent from "../../components/general/dialog/index";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import moment from "moment-jalaali";
import { numberFormat } from "highcharts";

import ProList from "@/Mixins/proList";
import PrintStudio from "@/modules/print/PrintStudio.vue";
import ProListFrame from "@/components/proList/ProListFrame.vue";
export default {
  name: "CheckList",
  provide() {
    return { checksList: this };
  },
  components: {
    ProListFrame,
    ChequeStudio,
    TreasuryReceiptPrint,
    AccountingDocView,
    PrintStudio,
    ChecksListDesktopBridge,
    ChecksListMobile,
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Tag: () => import("../../components/general/Tag/tag"),
    documentPrint,
    checkStatus,
    dialogComponent,
    Task,
    MyIcon,
    Upload,
  },
  mixins: [General, ProList],
  props: ["input", "refId", "typeProp", "mobileShow", "statusProp", "titleProp"],
  data: () => ({
    excelItems: [],
    printHeaders: [],
    selected: [],
    pageCount: 1,
    page: 1,
    printDialog: false,
    cashBox: null,
    registerar: null,
    removedChecks: null,
    summary: null,
    listViewportObserver: null,
    listViewportRaf: null,
    bankRecieve: null,
    account: null,
    bank: null,
    currencyFilter: null,
    deletDialog: false,
    uploadDialog: false,
    documentPrintDialog: false,
    checkStatusDialog: false,
    showSelect: true,
    filter: false,
    dialogData: null,
    statusItems: [],
    documentId: null,
    checkItem: null,
    fromDate: null,
    toDate: null,
    lastStatus: null,
    lastStatusItemIndex: null,
    productStatus: null,
    productStatusItems: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    status: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    snakbarColor: null,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    selectedHeaders: [],
    options: {
      itemsPerPage: 5,
    },
    // Separate from General mixin money `options` (beforeMount overwrites it).
    tableOptions: {
      page: 1,
      itemsPerPage: 10,
    },
    headers: null,
    type: null,
    search: null,
    selectedCheck: [],
    checkAverageDialog: false,
    selectedDate: null,
    today: null,
    checkAverageItems: null,
    checkDeleteDialog: false,
    deleteAllCheck: false,
    selectedCheckID: null,
    checksID: [],
    checksTotal: 0,
    checkAverageDate: null,
    invoice_without_due_date: null,
    isThereInvoiceWithoutId: false,
  }),
  // UI-only state outside data() (list payloads must stay clean).
  created() {
    this.chequeStudio = Vue.observable({ open: false, items: [], subtitle: "" });
    this.docView = Vue.observable({ open: false, item: null });
  },
  computed: {

    checksFilterDialogTitle() {
      if (this.$route.name === "payCheckList" || this.type === "payCheck") {
        return this.$t("payCheckFilterTitle");
      }
      if (this.$route.name === "removedChecks" || this.type === "removedChecks") {
        return this.$t("removedChecksFilterTitle");
      }
      return this.$t("receiveCheckFilterTitle");
    },
    activeFilterChips() {
      var app = this;
      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0;
        return v !== null && v !== undefined && v !== "" && v !== "0" && v !== 0;
      };
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0]);
        if (v && typeof v === "object") return v.name || v.text || v.label || "";
        return typeof v === "number" || typeof v === "string" ? String(v) : "";
      };
      var pick = function (items, v, key) {
        var arr = Array.isArray(v) ? v : [v];
        return arr
          .map(function (x) {
            var f = (items || []).find(function (i) {
              return i.value === x;
            });
            return f ? f[key || "text"] : "";
          })
          .filter(Boolean)
          .join("، ");
      };
      var defs = [
        ["account", app.type == "payCheck" ? app.$t("reciever") : app.$t("payer")],
        ["bank", app.$t("bank")],
        ["bankRecieve", app.$t("bank")],
        ["currencyFilter", app.$t("currency")],
        ["status", app.$t("status"), pick(app.statusItems, app.status)],
        ["tag", app.$t("tag")],
        ["cashBox", app.$t("cashBox")],
        ["registerar", app.$t("registerar")],
        ["fromDate", app.$t("from") + " " + app.$t("dueDate")],
        ["toDate", app.$t("until") + " " + app.$t("dueDate")],
        ["branch", app.$t("branch")],
        ["lockStatus", app.$t("lockStatusDocuments"), pick(app.lockStatusItems, app.lockStatus)],
      ];
      return defs
        .filter(function (d) {
          return has(app[d[0]]);
        })
        .map(function (d) {
          return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) };
        });
    },
    receiptKind() {
      if (this.type === "payCheck") return "chequePay";
      if (this.type === "recieveCheck") return "chequeReceive";
      return "";
    },
    // What can be printed on a cheque leaf (positions live in the template).
    chequeFields() {
      var app = this;
      // Amount in figures without thousands separators (cheque boxes).
      var amount = function (c) {
        var d = c.currency ? Number(c.currency.decimal) || 0 : 0;
        return String(Number((Number(c.amount) || 0).toFixed(d)));
      };
      var acc = function (c) {
        return c.payed_account || c.account || {};
      };
      return [
        { key: "date", label: this.$t("chequeFieldDate"), value: function (c) { return c.due_date || ""; } },
        { key: "dateWords", label: this.$t("chequeFieldDateWords"), value: function (c) { return jalaliDateWords(c.due_date); } },
        {
          key: "amountWords",
          label: this.$t("chequeFieldAmountWords"),
          value: function (c) {
            return c.amount ? numberToWords(c.amount) + " " + (c.currency && c.currency.name ? c.currency.name : app.$t("rial")) : "";
          },
        },
        { key: "amount", label: this.$t("chequeFieldAmount"), value: function (c) { return c.amount ? amount(c) : ""; } },
        { key: "payee", label: this.$t("chequeFieldPayee"), value: function (c) { return acc(c).name || c.owner_name || ""; } },
        {
          key: "payeeCode",
          label: this.$t("chequeFieldPayeeCode"),
          value: function (c) { var a = acc(c); return a.national_code || a.nationalCode || a.national_id || ""; },
        },
        { key: "sayad", label: this.$t("fishermanNumber"), value: function (c) { return c.fisherman_number || ""; } },
        { key: "description", label: this.$t("description"), value: function (c) { return c.content || c.description || ""; } },
      ];
    },
    proListKey() {
      return this.checksListColumnPersistKey;
    },
    proListLocked() {
      return this.checksListLockedColumns;
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        return app.selectedHeaders.includes(s);
      });
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isDesktopListLayout() {
      if (this.mobileShow) return true;
      return this.$vuetify.breakpoint.width >= 800;
    },
    isDesktopListViewport() {
      return !this.isMobile && !this.mobileShow;
    },
    checksListColumnPersistKey() {
      return "treasury-checks-list-columns-" + (this.$route.name || "recieveCheckList");
    },
    checksListLockedColumns() {
      // Fixed sticky block: select + actions + id + check number (no unpin/drag)
      var locked = ["actions", "id", "number"];
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    checksListColumnPlugins() {
      // show-select inserts a leading checkbox <th>; pad visibleHeaders so
      // pin/resize/drag index mapping stays aligned with thead cells.
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.checksListLockedColumns,
        anchor: "number",
        minWidth: 60,
        persistKey: this.checksListColumnPersistKey,
      };
    },
    totals: function () {
      const totals = this.items.reduce(
        (acc, d) => {
          acc.sum += parseFloat(d.amount);
          return acc;
        },
        {
          sum: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    type() {
      if (this.mobileShow) {
        if (this.type === "payCheck") {
          this.status = ["issued"];
        } else {
          this.status = ["fund"];
        }
      }
      this.getItems();
    },
    lastStatus() {
      this.items[this.lastStatusItemIndex].status = this.lastStatus;
      this.checkStatusDialog = false;
    },
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      const validItems = this.selected.filter((item) => item.due_date != null);
      this.selectedCheck = validItems;
      this.invoice_without_due_date = this.selected.filter(
        (item) => item.due_date == null
      );

      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      app.page = 1;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        if (app.tableOptions && app.tableOptions.page !== 1) {
          app.tableOptions.page = 1;
        } else {
        app.getItems();
        }
      }, 1000);
    },
    tableOptions: {
      handler() {
        var app = this;
        app.sortBy = [];
        const sortBy = (app.tableOptions && app.tableOptions.sortBy) || [];
        sortBy.forEach(function (value) {
          const index = (app.headers || []).findIndex((h) => h.value === value);
          if (index > -1 && app.headers[index].table) {
          app.sortBy.push(app.headers[index].table);
          }
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    summary() {
      if (this.isDesktopListViewport) {
        this.scheduleDesktopTableHeightUpdate();
      }
    },
    loading(val) {
      if (!val && this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      }
    },
    isDesktopListViewport(val) {
      if (val) {
        this.$nextTick(() => {
          this.updateDesktopTableHeight();
          this.bindListViewportObserver();
        });
      } else {
        this.unbindListViewportObserver();
        this.tableHeight = window.innerHeight - 245;
      }
    },
    checkAverageDialog(val) {
      if (val) {
        this.selectedDate = this.today;
        this.checkAverageItems = this.selectedCheck;
      }
    },
    checkAverageItems(val) {
      this.selected = val;
      this.resolveChecksTotal();
    },
  },
  activated() {
    this.getItems();
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.scheduleDesktopTableHeightUpdate();
      });
    }
  },
  beforeMount() {
    this.statusItems = [
      {
        value: "fund",
        text: this.$t("fund"),
      },
      {
        value: "issued",
        text: this.$t("issued"),
      },
      {
        value: "returned",
        text: this.$t("returned"),
      },
      {
        value: "passed",
        text: this.$t("passed"),
      },
      {
        value: "bank",
        text: this.$t("inBank"),
      },
      {
        value: "payed",
        text: this.$t("payed"),
      },
      {
        value: "canceled",
        text: this.$t("canceled"),
      },
    ];
    if (this.$route.name === "payCheckList") {
      this.type = "payCheck";
    }
    if (this.$route.name === "recieveCheckList") {
      this.type = "recieveCheck";
    }
    if (this.$route.name === "removedChecks") {
      this.type = "removedChecks";
      this.removedChecks = "active";
    }
    if (this.typeProp) {
      this.type = this.typeProp;
    }
    if (this.statusProp) {
      this.status = [this.statusProp];
    }
    this.headers = [
      {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
      {
        text: this.$t("id"),
        sortable: true,
        value: "id",
        table: "checks.id",
      },
      {
        text: this.$t("number") + " " + this.$t("document"),
        sortable: false,
        value: "doc_header.number",
      },
      {
        text: this.$t("name") + " " + this.$t("account"),
        sortable: false,
        value: "account.name",
      },
      {
        text: this.$t("number") + " " + this.$t("check"),
        sortable: false,
        value: "number",
      },
      {
        text: this.$t("bank"),
        sortable: false,
        value: "bank",
      },
      {
        text: this.$t("kind"),
        sortable: false,
        value: "kind",
      },
      {
        text: this.$t("date"),
        sortable: true,
        value: "date",
        table: "checks.date",
      },
      {
        text: this.$t("dueDate"),
        sortable: true,
        value: "due_date",
        table: "checks.due_date",
      },
      {
        text: this.$t("check_owner_name"),
        sortable: false,
        value: "owner_name",
      },
      {
        text: this.$t("fishermanNumber"),
        sortable: true,
        value: "fisherman_number",
        table: "checks.fisherman_number",
      },
      {
        text: this.$t("branch"),
        sortable: false,
        value: "branch.name",
      },
      {
        text: this.$t("amount"),
        sortable: false,
        width: 100,
        value: "amount",
      },
      {
        text: this.$t("currency"),
        sortable: false,
        value: "currency",
      },
      {
        text: this.$t("status"),
        sortable: true,
        value: "status.status",
        table: "checks_status.status",
      },
      {
        text: this.$t("relations"),
        sortable: false,
        value: "relations",
      },
      {
        text: this.$t("tag"),
        sortable: false,
        value: "tags",
      },
      {
        text: this.$t("content"),
        sortable: false,
        value: "content",
        table: "bank_cash.content",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    this.printHeaders = [
      {
        text: this.$t("id"),
        value: "id",
      },
      {
        text: this.$t("number") + " " + this.$t("document"),
        value: "doc_header",
      },
      {
        text: this.$t("name") + " " + this.$t("account"),
        value: "account",
      },
      {
        text: this.$t("number") + " " + this.$t("check"),
        value: "number",
      },
      {
        text: this.$t("bank"),
        value: "bank_name",
      },
      {
        text: this.$t("kind"),
        value: "kind",
        type: "translate",
      },
      {
        text: this.$t("date"),
        value: "date",
      },
      {
        text: this.$t("dueDate"),
        value: "due_date",
        width: 15,
      },
      {
        text: this.$t("check_owner_name"),
        value: "owner_name",
        width: 10,
      },
      {
        text: this.$t("status"),
        value: "lastStatus",
      },
      {
        text: this.$t("amount"),
        width: 10,
        type: "number",
        value: "amount",
        sum: true,
      },
    ];
    if (this.$route.params.id != null) {
      this.show();
      this.id = this.$route.params.id;
      this.render = false;
    }
    this.selectedHeaders = this.headers;
    reorderPinnedHeaders(this.headers, {
      locked: this.checksListLockedColumns,
      anchor: "number",
    });
    this.loadChecksListColumnSettings();
    this.checkAverageHeaders = [
      {
        text: this.$t("#"),
        align: "start",
        sortable: false,
        value: "row",
        width: 25,
      },
      {
        text: this.$t("check-number"),
        align: "start",
        sortable: false,
        value: "checkNumber",
      },
      {
        text: this.$t("detailsInvoice"),
        align: "start",
        sortable: false,
        value: "detailsInvoice",
      },
      {
        text: this.$t("dueDate"),
        align: "start",
        sortable: false,
        value: "dueDate",
      },
      {
        text: this.$t("amount"),
        align: "start",
        sortable: false,
        value: "amount",
      },
      {
        text: this.$t("bank"),
        align: "start",
        sortable: false,
        value: "bank",
      },
      {
        text: this.$t("edit"),
        align: "start",
        sortable: false,
        value: "edit",
      },
    ];
  },
  mounted() {
    this.setToday();
    if (this.input) {
      this.model = this.input;
    }
    this.getItems();
    if (this.isDesktopListViewport) {
      this.$nextTick(() => {
        this.bindListViewportObserver();
        this.updateDesktopTableHeight();
        this.$nextTick(() => {
          this.bindListViewportObserver();
          this.scheduleDesktopTableHeightUpdate();
        });
      });
    }
  },
  deactivated() {
    this.unbindListViewportObserver();
  },
  beforeDestroy() {
    this.unbindListViewportObserver();
    if (this.listViewportRaf) {
      cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = null;
    }
  },
  methods: {

    resetFilters() {
      var app = this;
      [
        "account", "bank", "bankRecieve", "currencyFilter", "status", "tag",
        "cashBox", "registerar", "fromDate", "toDate", "branch", "lockStatus",
      ].forEach(function (k) {
        app[k] = null;
      });
    },

    resolveRefEl(ref) {
      if (!ref) return null;
      return ref.$el || ref;
    },
    onResize() {
      if (this.isDesktopListViewport) {
        this.updateDesktopTableHeight();
        return;
      }
      this.tableHeight = window.innerHeight - 245;
    },
    scheduleDesktopTableHeightUpdate() {
      if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf);
      this.listViewportRaf = requestAnimationFrame(() => {
        this.listViewportRaf = null;
        this.updateDesktopTableHeight();
      });
    },
    updateDesktopTableHeight() {
      if (!this.isDesktopListViewport) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const toolbarEl = this.resolveRefEl(this.$refs.listToolbar);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      if (!rootEl || !tableColEl) {
        this.tableHeight = window.innerHeight - 245;
        return;
      }
      const rootStyle = window.getComputedStyle(rootEl);
      const rootPadding =
        (parseFloat(rootStyle.paddingTop) || 0) +
        (parseFloat(rootStyle.paddingBottom) || 0);
      const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0;
      let summaryHeight = 0;
      if (summaryEl) {
        const summaryVisible =
          summaryEl.offsetParent !== null ||
          summaryEl.getClientRects().length > 0;
        if (summaryVisible) {
          const summaryStyle = window.getComputedStyle(summaryEl);
          summaryHeight =
            summaryEl.offsetHeight +
            (parseFloat(summaryStyle.marginTop) || 0) +
            (parseFloat(summaryStyle.marginBottom) || 0);
        }
      }
      const colStyle = window.getComputedStyle(tableColEl);
      const colPadding =
        (parseFloat(colStyle.paddingTop) || 0) +
        (parseFloat(colStyle.paddingBottom) || 0);
      const footerEl = tableEl
        ? tableEl.querySelector(".v-data-footer")
        : null;
      const footerHeight = footerEl ? footerEl.offsetHeight : 0;
      const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null;
      const tableMargins = tableStyle
        ? (parseFloat(tableStyle.marginTop) || 0) +
          (parseFloat(tableStyle.marginBottom) || 0)
        : 0;
      const available =
        rootEl.clientHeight -
        rootPadding -
        toolbarHeight -
        summaryHeight -
        colPadding -
        footerHeight -
        tableMargins -
        3;
      this.tableHeight = Math.max(180, Math.floor(available));
    },
    bindListViewportObserver() {
      if (typeof ResizeObserver === "undefined") return;
      this.unbindListViewportObserver();
      const rootEl = this.resolveRefEl(this.$refs.listRoot);
      const summaryEl = this.resolveRefEl(this.$refs.listSummary);
      const tableColEl = this.resolveRefEl(this.$refs.listTableCol);
      const tableEl = this.resolveRefEl(this.$refs.listTable);
      const footerEl = tableEl ? tableEl.querySelector(".v-data-footer") : null;
      if (!rootEl && !summaryEl && !tableColEl) return;
      this.listViewportObserver = new ResizeObserver(() => {
        this.scheduleDesktopTableHeightUpdate();
      });
      if (rootEl) this.listViewportObserver.observe(rootEl);
      if (summaryEl) this.listViewportObserver.observe(summaryEl);
      if (tableColEl) this.listViewportObserver.observe(tableColEl);
      if (footerEl) this.listViewportObserver.observe(footerEl);
    },
    unbindListViewportObserver() {
      if (this.listViewportObserver) {
        this.listViewportObserver.disconnect();
        this.listViewportObserver = null;
      }
    },
    loadChecksListColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.checksListColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: app.checksListLockedColumns,
          anchor: "number",
        });
        app.$forceUpdate();
      });
    },
    openUploadDialog() {
      if (this.$root && this.type === "recieveCheck") {
        this.$root.$emit("open-user-file-process", { type: "receiveChecks" });
      }
    },
    setToday() {
      var m = moment();
      if (this.$store.state.date_locale === "fa,en") {
        const shamsiYear = m.jYear();
        const shamsiMonth = String(m.jMonth() + 1).padStart(2, "0");
        const shamsiDay = String(m.jDate()).padStart(2, "0");
        this.today = `${shamsiYear}/${shamsiMonth}/${shamsiDay}`;
      }
      if (this.$store.state.date_locale === "en,fa") {
        this.today = m.format("YYYY/MM/DD");
      }
    },
    openComponent(component, id) {
      this.dialogData = {
        name: component,
        id: id,
      };
      this.innerComponent = true;
    },
    // View the linked accounting document (same dialog as the accounting list).
    viewDocument(item) {
      var id = item && (item.doc_head_id || (item.doc_header && item.doc_header.id));
      if (!id) return;
      this.docView.item = { id: id, lock: item.lock };
      this.docView.open = true;
    },
    openDocEdit(doc) {
      this.docView.open = false;
      this.$router.push({ name: "accountingEdit", params: { id: doc.id } });
    },
    // Printed receipt (single row or group, list order) via the print module.
    receiptPrint(item, picked) {
      var list = item ? [item] : (picked || this.selected || []).slice();
      if (!list.length || !this.receiptKind) return;
      var order = this.items || [];
      var pos = function (x) {
        var i = order.findIndex(function (r) { return r.id === x.id; });
        return i < 0 ? Number.MAX_SAFE_INTEGER : i;
      };
      list.sort(function (a, b) { return pos(a) - pos(b); });
      this.$refs.receiptPrint.open(list);
    },
    // Print on the cheque leaf (paid cheques) through the print module.
    chequePrint(item) {
      var list = item ? [item] : this.selected && this.selected.length ? this.selected : [];
      if (!list.length) return;
      this.chequeStudio.items = list;
      this.chequeStudio.subtitle = [
        item && item.number ? this.$t("number") + ": " + item.number : "",
        item && item.account ? item.account.name : "",
      ].filter(Boolean).join(" · ");
      this.chequeStudio.open = true;
    },
    documentPrint(item) {
      this.documentId = item.doc_head_id;
      this.documentPrintDialog = true;
    },
    openCheckStatusDialog(item) {
      this.checkItem = item;
      this.checkStatusDialog = true;
      this.lastStatusItemIndex = this.items.indexOf(item);
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    editLink(item) {
      if (!item) return "";
      // Align with list edit route (payCheck/recieveCheck), not item.type own/customer.
      let editPath = "check/recieve/edit";
      if (this.type === "payCheck") {
        editPath = "check/pay/edit";
      } else if (this.type === "removedChecks") {
        editPath =
          item.type === "own" ? "check/pay/edit" : "check/recieve/edit";
      }
      return this.$baseURL + "/" + editPath + "/" + item.id;
    },
    edit(item) {
      if (item.lock) {
        return false;
      }
      if (!this.removedChecks) {
        this.$router.push({ name: this.type + "Edit", params: { id: item.id } });
      }
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.filter = false;
      var bankRecieve = [];
      if (app.bankRecieve) {
        app.bankRecieve.map(function (val, index) {
          bankRecieve.push(val.name);
        });
      }
      app.$axios
        .get(this.$endpoint + "checks", {
          params: {
            account: app.account,
            bank: app.bank,
            bankRecieve: bankRecieve,
            from: app.fromDate,
            to: app.toDate,
            currencyFilter: app.currencyFilter,
            branch: app.branch,
            search: app.search,
            page: app.allRows ? app.excelPage : ((app.tableOptions && app.tableOptions.page) || 1),
            refId: app.refId,
            lockStatus: app.lockStatus,
            type: app.type,
            cashBox: app.cashBox,
            sortBy: app.sortBy,
            status: app.status,
            options: app.tableOptions,
            tag: app.tag,
            registerar: app.registerar,
            typeForm: app.typeForm,
            removedChecks: app.removedChecks,
          },
        })
        .then((res) => {
          res = res.data;
          if (!app.allRows) {
            app.items = res.data;
            app.totalItems = res.total;
            app.pageCount = res.last_page;
            app.from = res.from;
            app.summary = res.summary;
            app.creatExcelData(res.data);
          } else {
            app.generateExcellForAllData(res.data, res.last_page);
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "checks/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push({ id: value.id });
      });
      app.$axios
        .delete(this.$endpoint + "checks/0", {
          params: { deleteItems: selected },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    lock(item, type) {
      if (this.$store.state.userCurrentPlan != null) {
        const lockItem = this.$store.state.userCurrentPlan.plan.options.find(
          (item) => item.key == "lockSystem"
        );
        if (lockItem && lockItem.value == "deactive") {
          this.$store.commit("SET_PLAN_DIALOG", true);
          this.$router.replace("/");
        } else {
          this.selected = [item];
          this.lockGroup(type);
        }
      }
    },
    // add unlock group send type
    unlockGroup(type = "unlock") {
      this.lockGroup(type);
    },
    lockGroup(type) {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "checks", {
          params: {
            lock: "active",
            id: selected,
            type: type,
          },
        })
        .then((res) => {
          res = res.data;
          app.snakbarText = this.$t("opertationSuccess");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.getItems();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.loading = false;
          app.selected = [];
        });
    },
    refreshRemovedItem() {
      var app = this;
      app.loading = true;
      var selected = [];
      app.selected.map(function (value, key) {
        selected.push(value.id);
      });
      app.$axios
        .get(this.$endpoint + "checks", {
          params: {
            refreshRemovedChecks: "active",
            items: selected,
          },
        })
        .then((res) => {
          res = res.data;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    creatExcelData(data, type = "page") {
      var app = this;
      if (type === "page") {
        app.excelItems = [];
      }
      data.map(function (d) {
        app.excelItems.push({
          id: d.id,
          number: d.number,
          accountId: d.account_id,
          bank:
            d.type === "own"
              ? d.bank.name + "-" + d.bank.number
              : d.type === "customer"
              ? d.bank_name + "-" + d.bank_account_number
              : "",
          amount: d.amount,
          date: d.date,
          check_owner_name: d.owner_name || "",
          content: d.content,
          fishermanNumber: d.fisherman_number,
          dueDate: d.due_date,
          documentNumber: d.doc_header ? d.doc_header.number : "",
          account: d.account ? d.account.name : "",
          user: d.user ? d.user.name : "",
        });
      });
    },
    openCheckDeleteDialog(select, checkId) {
      this.checkDeleteDialog = true;
      if (select == "all") {
        this.deleteAllCheck = true;
      } else {
        this.deleteAllCheck = false;
        this.selectedCheckID = checkId;
      }
    },
    deleteCheck() {
      if (this.deleteAllCheck) {
        this.checkAverageItems = [];
        this.selected = [];
      } else {
        const selectedCheckIndexTable = this.checkAverageItems.findIndex(
          (item) => item.id == this.selectedCheckID
        );
        this.checkAverageItems.splice(selectedCheckIndexTable, 1);
      }
      this.checkDeleteDialog = false;
    },
    fetchCheckAverageFirst() {
      if (this.selectedCheck && this.selectedCheck.length == 0) {
        this.snakbarText =
          this.$t("first add some items from list") +
          "(" +
          this.$t("only checks with due-date can be calculated") +
          ")";
        this.snakbarColor = "red";
        this.snakbar = true;
      }

      if (this.invoice_without_due_date && this.invoice_without_due_date.length > 0) {
        this.isThereInvoiceWithoutId = true;
      }

      /* if (this.invoice_without_due_date != null) {
          const invoiceID_without_due_date = this.invoice_without_due_date.map(item => item.id)

          if (invoiceID_without_due_date.length > 0) {
            this.snakbarText = `${this.$t("selected item doesn't have due date")} : ${invoiceID_without_due_date.join(', ')}`
            this.snakbarColor = 'red'
            this.snakbar = true
          }
        } */

      this.selectedCheck.forEach((item) => {
        this.checksID.push(item.id);
      });
      if (this.checksID.length > 0) {
        var app = this;
        this.loading = true;
        app.$axios
          .post(app.$endpoint + "duedateInvoice/check", {
            ids: this.checksID,
            base_date: moment(this.today, "jYYYY/jM/jD").format("YYYY-MM-DD"),
          })
          .then((r) => {
            if (r.data) {
              this.checkAverageDate = r.data.due_date;

              if (this.checkAverageDate) {
                this.checkAverageDialog = true;
              }
              this.checksID = [];
              this.loading = false;
            }
          })
          .catch((err) => {
            if (
              err.response &&
              (err.response.status == 422 || err.response.status == 403)
            ) {
              this.snakbarText = this.$t("can't change to lower plan");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
            this.serverErrorHandeler(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    fetchCheckAverageSecond() {
      this.loading = true;
      this.checkAverageItems.forEach((item) => {
        this.checksID.push(item.id);
      });
      if (this.checksID.length > 0) {
        var app = this;
        app.$axios
          .post(app.$endpoint + "duedateInvoice/check", {
            ids: this.checksID,
            base_date: moment(this.selectedDate, "jYYYY/jM/jD").format("YYYY-MM-DD"),
          })
          .then((r) => {
            if (r.data) {
              this.checkAverageDate = r.data.due_date;
              this.checksID = [];
              this.loading = false;
            }
          })
          .catch((err) => {
            if (
              err.response &&
              (err.response.status == 422 || err.response.status == 403)
            ) {
              this.snakbarText = this.$t("can't change to lower plan");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
            this.serverErrorHandeler(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resolveChecksTotal() {
      this.checksTotal = this.checkAverageItems.reduce((sum, item) => {
        return sum + Number(item.amount);
      }, 0);
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";
</style>
